import { INavigationBlockItemBase } from '@cbridge-tools/navigation-block';
import { IClientLp } from '@cbridge-packages/lp-client';
import { generateLpSymbolsRoute } from '@cbridge-packages/routing-client-admin';

export const lpAsNavigationItem = (lp: IClientLp): INavigationBlockItemBase => ({
  value: lp.lpId,
  label: lp.name,
  href: generateLpSymbolsRoute(lp.lpId),
});
